<template>
    <div>
        <div :key="reRenderKey" id="printContent">
            <div v-for="order in localOrders" v-bind:key="order.orderId">
                <b-row>
                    <b-col class="ml-3" sm="4">
                        <h3 class="mb-0">CRAIG MOERER</h3>
                        <h4>RECORDS BY MAIL LLC</h4>
                        <p class="my-0">2541 NW 30th Ave.</p>
                        <p class="my-0">Portland, OR 97210</p>
                        <p class="mt-0">(503) 232-1735</p>
                    </b-col>

                    <b-col class="ml-auto mr-3 mt-1 text-center col-auto">
                        <img src="../../../public/assets/bw_wings1.jpg" class="img-fluid" style="width: 160px" />
                        <p class="mb-0">www.recordsbymail.com</p>
                        <p class="my-0">cmoerer@recordsbymail.com</p>
                    </b-col>
                </b-row>

                <order-details class="mt-5"
                               :order="order"
                               updated="{}"
                               printView="true"></order-details>

                <!--<b-row class="mt-5">-->
                    <!--<b-col>-->
                        <!--<em>Questions? Email us at </em><a class="link" href="#">cmoerer@recordsbymail.com</a>-->
                    <!--</b-col>-->
                <!--</b-row>-->

                <p style="page-break-after: always"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import CountryList from "../../assets/countryList";
    import itemBuilder from "../../builders/orderItem";
    import _ from "lodash";
    import ordersApi from "../../api/orders";
    import AddressMixin from "../../builders/address";
    import OrderDetails from "../../components/orders/OrderDetails";

    export default {
        name: "PrintView",
        mixins: [ CountryList, itemBuilder, ordersApi, AddressMixin ],
        components: { OrderDetails },
        props: [ 'orders', 'printTrigger' ],
        data() {
            return {
                localOrders: [],
                isLocalOrdersUpdated: false,
                reRenderKey: 0,
            }
        },
        methods: {
            formatNote(note) {
                let type = note.type ? _.capitalize(note.type) : '';

                return `${type} Note: ${note.text}`.trim();
            },
            itemTitle(item) {
                let str = '';

                str += `${this.artist(item)} `;
                str += `${this.title(item)}`;

                let format = this.format(item.release.media);

                if (format.length) {
                    str += ` (${format})`;
                }

                return str;
            },
            itemDetails(item) {
                return `${item.release.label.name} ${item.release.label.catalogNo}`;
            },
            itemCondition(item) {
                const conditions = item.listing.condition.map(condition => {
                    if (condition.subject) {
                        return `${condition.subject}: ${condition.grade}`;
                    }
                });

                return conditions.join(', ')
            },
            itemNotes(item) {
                return item.notes.map(note => {
                    return note.text;
                }).join(', ');
            },
            formatDate(date) {
                return new Date(date).toDateString();
            },
            async confirmMarkPrinted() {
                const isPulling = await this.$bvModal.msgBoxConfirm('Mark as printed and move to Warehouse?', {
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                });

                if (isPulling) {
                    this.orders.forEach(async order => {
                        const printEntry = {
                            username: this.$auth.user.nickname,
                        };

                        await this.addPrintEntry(order.orderId, { printing: printEntry });
                    });

                    this.$emit('printed');
                    this.$emit('moveToWarehouse');
                }
            },
            print() {
                if (this.isLocalOrdersUpdated) { 
                    this.$htmlToPaper('printContent', null, () => {
                    this.confirmMarkPrinted();
                    });
                }
            }
        },
        watch: {
             // Watch for changes in the order prop
            orders: {
                handler(newOrders) {
                // When order changes, update localOrder with a deep copy of newOrder
                this.localOrders = JSON.parse(JSON.stringify(newOrders));
                this.isLocalOrdersUpdated = true;
                this.reRenderKey++;
                },
                deep: true, // Watch for deep changes in the order object
                immediate: true, // Run the handler immediately after the watcher is created
            },
            printTrigger() {
                // trigger htmlToPaper on next tick
                this.$nextTick(() => {
                    this.print();
                });

            }
        }
    }
</script>

<style scoped>
    .link {
        text-decoration: underline;
    }
</style>